import { getBasePath } from "./base.js";

export function currentRoute() {
  const path = location.pathname;
  const base = getBasePath() === "/" ? "" : getBasePath().replace(/\/$/, "");
  let rest = path;
  if (base && path.startsWith(base)) rest = path.slice(base.length) || "/";
  rest = rest.replace(/\/index\.html$/, "/") || "/";

  let m;
  if ((m = rest.match(/^\/item\/([^/]+)\/?$/))) {
    return { name: "item", slug: decodeURIComponent(m[1]) };
  }
  if ((m = rest.match(/^\/boss\/([^/]+)\/?$/))) {
    return { name: "boss", slug: decodeURIComponent(m[1]) };
  }
  if (/^\/farm\/?$/.test(rest)) return { name: "farm" };
  if (/^\/bosses\/?$/.test(rest)) return { name: "bosses" };
  if (/^\/cart\/?$/.test(rest)) return { name: "cart" };
  return { name: "home" };
}

export function navigate(routeName, slug) {
  const base = getBasePath();
  let url = base;
  if (routeName === "item" && slug) url = `${base}item/${encodeURIComponent(slug)}/`;
  else if (routeName === "boss" && slug) url = `${base}boss/${encodeURIComponent(slug)}/`;
  else if (routeName === "farm") url = `${base}farm/`;
  else if (routeName === "bosses") url = `${base}bosses/`;
  else if (routeName === "cart") url = `${base}cart/`;
  history.pushState({ routeName, slug }, "", url);
  window.dispatchEvent(new PopStateEvent("popstate"));
}
